import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckOutlined, MinusOutlined } from "@ant-design/icons-svg";
import { Fragment } from "react";
import { extendCommonStylesheet } from "@devowl-wp/web-cookie-banner";
import { useStylesheet } from "../../contexts/stylesheet.js";
import { PlainAntdIconAsSvg } from "../plainAntdIconAsSvg.js";
const Checkbox = (param)=>{
    let { hideCheckbox, isPartial, isChecked, isDisabled, fontSize, onToggle, children, after, "aria-describedby": ariaDescribedby, ...rest } = param;
    const { checkbox: { className, style }, Label } = useStylesheet().extend(...extendCommonStylesheet);
    const CheckboxIcon = isPartial ? MinusOutlined : CheckOutlined;
    const handleChange = (e)=>{
        const { checked } = e.target;
        onToggle == null ? void 0 : onToggle(checked);
    };
    return /*#__PURE__*/ _jsxs(Label, {
        children: [
            !hideCheckbox && /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        name: "checkbox[]",
                        type: "checkbox",
                        value: "1",
                        checked: isChecked,
                        disabled: isDisabled,
                        className: className,
                        style: style({
                            fontSize
                        }),
                        onChange: handleChange,
                        "aria-describedby": ariaDescribedby
                    }),
                    /*#__PURE__*/ _jsx(PlainAntdIconAsSvg, {
                        "aria-hidden": true,
                        icon: CheckboxIcon,
                        ...rest
                    })
                ]
            }),
            children && /*#__PURE__*/ _jsxs("span", {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        children: children
                    }),
                    after && /*#__PURE__*/ _jsx("span", {
                        onClick: (e)=>{
                            // Do not modify the checkbox
                            e.stopPropagation();
                        },
                        children: after
                    })
                ]
            })
        ]
    });
};
export { Checkbox };
